import React from 'react'
import { Link } from 'react-router-dom'

import './VinstriLinkur.scss'

export default function VintriLinkur(props) {
  const {
    linkur,
    prismicCtx
  } = props


  if (linkur.linkur.link_type === 'Web') {
    return (
      <a
        style={{ margin: '0px 15px' }}
        href={linkur.linkur.url}
        target='_blank'
        className={`vinstriLinkur__nav-link vinstriLinkur__nav-link-ltr-black`}
      >
        {linkur.titill[0].text}
      </a>
    )
  } else {
    return (
      <Link
        style={{ margin: '0px 15px' }}
        to={prismicCtx.linkResolver(linkur.linkur)}
        target='_blank'
        className={`vinstriLinkur__nav-link vinstriLinkur__nav-link-ltr-black`}
      >
        {linkur.titill[0].text}
      </Link>
    )
  }
}